var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgVe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 181.793h512v148.413H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M367.304 285.852l-8.033 6.276 3.488 9.577-8.453-5.699-8.032 6.275 2.809-9.798-8.451-5.701 10.188-.355 2.811-9.798 3.487 9.579zm-20.569-35.625l-5.4 8.645 6.552 7.808-9.891-2.464-5.402 8.643-.712-10.169-9.891-2.466 9.452-3.819-.71-10.17 6.553 7.81zm-31.512-26.442l-2.118 9.971 8.827 5.096-10.137 1.069-2.121 9.968-4.146-9.311-10.137 1.064 7.575-6.821-4.146-9.311 8.829 5.096zm-38.655-14.069l1.419 10.094 10.039 1.77-9.162 4.47 1.418 10.094-7.081-7.332-9.163 4.467 4.786-9.001-7.081-7.33 10.04 1.768zm-41.136 0l4.787 9 10.037-1.77-7.081 7.334 4.785 9.001-9.161-4.469-7.082 7.331 1.42-10.093-9.163-4.468 10.04-1.772zm-38.656 14.069l7.578 6.821 8.825-5.096-4.144 9.314 7.574 6.82-10.137-1.066-4.147 9.311-2.117-9.97-10.139-1.064 8.829-5.098zm-31.511 26.442l9.453 3.818 6.55-7.808-.709 10.171 9.45 3.819-9.891 2.465-.712 10.167-5.399-8.643-9.892 2.465 6.552-7.809zm-20.569 35.625l10.19.356 3.484-9.578 2.813 9.799 10.186.357-8.452 5.7 2.81 9.798-8.032-6.276-8.45 5.699 3.486-9.579z",
  fill: "#f0f0f0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.337h512v96.456H0z"
})));

export default SvgVe;